// src/components/store/sections/gallery/GalleryV87CinemareelCrimsonRose.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV87CinemareelCrimsonRose(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={87}
      archKey="cinema_reel"
      archLabel="Cinema Filmstrip Reel"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
